module.exports = __webpack_public_path__ + "assets/images/25R.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/25R.png
// module id = 1298
// module chunks = 1